import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TrustPaymentPageRoutingModule } from './trust-payment-routing.module';

import { TrustPaymentPage } from './trust-payment.page';
import { MasterHeaderModule } from '../../../master-header/master-header.module';
import { MasterFooterModule } from '../../../master-footer/master-footer.module';
import { CustomInputModule } from '../../../common-components/custom-input/custom-input.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    TrustPaymentPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
    CustomInputModule,
    TranslateModule
  ],
  declarations: [TrustPaymentPage],
})
export class TrustPaymentPageModule {}
